const DATE_OPTIONS = { month: 'short', day: 'numeric' };
const TIME_OPTIONS = { hour: 'numeric', minute: '2-digit' };
function format(iso, timeZone, options) {
    if (!iso)
        return '—';
    const date = new Date(iso);
    if (Number.isNaN(date.getTime()))
        return iso;
    return new Intl.DateTimeFormat(undefined, Object.assign(Object.assign({}, options), { timeZone })).format(date);
}
export function formatDate(iso, timeZone) {
    return format(iso, timeZone, DATE_OPTIONS);
}
export function formatTime(iso, timeZone) {
    return format(iso, timeZone, TIME_OPTIONS);
}
export function formatDateTime(iso, timeZone) {
    return format(iso, timeZone, Object.assign(Object.assign({}, DATE_OPTIONS), TIME_OPTIONS));
}
